
import TopSectionTitle from '~/components/common/TopSectionTitle.vue'

export default {
  components: {
    TopSectionTitle
  }
}
